<template>
  <div class="text-center">
    <v-btn v-if="false" color="red lighten-2" dark v-bind="attrs" @click="sendOTP"> Click Me </v-btn>
    <v-dialog v-model="dialog" max-width="380" persistent>
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn icon @click="closeOTP">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title v-if="enableOTP" primary-title class="justify-center">
          <div class="text-center">
            <h3 class="headline text--accent-2 font-weight-bold">
              ยืนยันรหัส OTP
              <div v-if="mode !== 'production'">{{ mode }}</div>
            </h3>
            <div :class="'text-subtitle-2 ' + obj.class">{{ obj.title }}</div>
            <div class="text-subtitle-2 text-no-wrap">กรุณากรอกรหัส OTP ที่ส่งไปทาง Line/email</div>
            <div class="text-subtitle-2">(Ref: {{ appl }})</div>
          </div>
        </v-card-title>
        <v-card-title v-else primary-title class="justify-center">
          <div class="text-center">
            <h3 class="headline text--accent-2 font-weight-bold">ยืนยัน</h3>
            <div :class="'text-subtitle-2 ' + obj.class">{{ obj.title }}</div>
            <div class="text-subtitle-2">(Ref: {{ appl }})</div>
          </div>
        </v-card-title>

        <v-card-text v-if="enableOTP" class="text-center">
          <v-text-field x-large height="100" densep outlined v-model="otpTEXT" :error-messages="error" class="centered-input" :counter="6" background-color="yellow lighten-4" clearable @keydown.enter="checkOTP"></v-text-field>
          <!-- color="blue-grey" -->
          <!-- class="ma-2 white--text" -->
          <div>
            <v-btn v-show="otpTime <= 0" :loading="loading" :disabled="loading || !this.$store.getters.lineStatus" class="green" @click="sendOTP">
              ส่งรหัส OTP ใหม่ [Line]
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
            <v-btn v-if="emailShow" v-show="otpTime <= 0" :loading="loading" :disabled="loading" class="primary ml-3" @click="sendEmailOTP" text-small>
              <small>ส่งรหัส OTP ใหม่ <br />[{{ $store.state.users.main.EmailAddress }}]</small>
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
            <p v-show="otpTime > 0">ส่งรหัส OTP ได้อีกครั้งในอีก {{ otpTime }}</p>
          </div>
        </v-card-text>
        <v-card-text v-if="obj.message_label">
          <v-textarea name="input-7-1" ref="msg" :label="obj.message_label" v-model="obj.message" :hint="obj.message_hint"></v-textarea>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="enableOTP" :disabled="otpTEXT.length !== 6" block x-large color="primary" @click="checkOTP"> ยืนยัน </v-btn>
          <v-btn v-else block x-large color="primary" @click="skipOTP"> ยืนยัน </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import bookServ from '@/store/api/services/bookService'
export default {
  name: 'otp',
  props: {
    // rules: {
    //   type: Array
    // },
    appl: {
      type: String,
      default: 'TAI'
    },
    emailShow: {
      type: Boolean,
      default: true
    },
    enable2FA: {
      type: Boolean,
      default: false
    },
    messageOnly: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default() {
        return {
          otp: 'true'
        }
      }
    }
  },
  data() {
    return {
      apiPath: process.env.VUE_APP_API_PATH,
      staticPath: process.env.VUE_APP_STATIC,
      mode: process.env.NODE_ENV,
      dialog: false,
      loader: null,
      loading: false,
      otpTime: 30,
      otpTEXT: '',
      mail: {
        From: 'TAI Intranet',
        To: '',
        Cc: '',
        Bcc: this.$store.state.users.main.EmailAddress,
        Subject: 'OTP จากระบบ TAI Intranet',
        BodyPart: '',
        ReplyTo: this.$store.state.users.main.EmailAddress
      },
      user: {
        username: '',
        password: ''
      },
      redirect: '',
      valid: false,
      ok: false,
      runT: '',
      error: '',
      nameRules: [(v) => !!v || 'กรุณาใส่ UserName', (v) => v.length >= 3 || 'ชื่อต้องไม่น้อยกว่า 3 ตัวอักษร'],
      passwordRules: [(v) => !!v || 'กรุณาใส่ Password', (v) => v.length >= 6 || 'ชื่อต้องไม่น้อยกว่า 6 ตัวอักษร']
    }
  },
  watch: {
    loader() {
      const l = this.loader
      this.otpTime = 60
      this[l] = !this[l]

      setTimeout(() => {
        this[l] = false
      }, 60000)

      this.loader = null
    },
    otpTEXT() {
      this.err = ''
    }
  },
  mounted() {},
  computed: {
    enableOTP() {
      if ((this.$store.getters.prConfig.enable_2fa === 'Y' || this.enable2FA) && !this.messageOnly) {
        return true
      }
      return false
    }
  },
  methods: {
    showOTP() {
      this.otpTime = 0
      this.dialog = true
    },
    async sendEmailOTP() {
      if (!this.enableOTP) {
        return true
      }
      this.otpTime = 60
      this.runT = setInterval(() => {
        // this.decrementTime()
        this.otpTime--
        if (this.otpTime < 0) {
          clearInterval(this.runT)
        }
      }, 1000)
      this.dialog = true
      if (!this.$store.state.users.main.EmailAddress) {
        alert('กรุณาตั้งค่า email')
        this.otpTime = 0
        return false
      }
      let message
      if (process.env.NODE_ENV === 'production') {
        message = { emp: this.$store.state.users.main.empCode, app: this.appl, message: this.obj.message }
      } else {
        message = { emp: '0090', app: this.appl, message: this.obj.message }
      }

      let res = await this.$store.dispatch('emailOTP', message)
      if (res.status !== 200) {
        this.error = 'send OTP Error ' + res.message
      } else {
        this.error = ''
      }
      // .then(res =>{ console.log(res)}
      // .catch(err => {console.log(err)})
    },
    async sendOTP() {
      if (!this.enableOTP) {
        return true
      }
      this.otpTime = 60
      this.runT = setInterval(() => {
        // this.decrementTime()
        this.otpTime--
        if (this.otpTime < 0) {
          clearInterval(this.runT)
        }
      }, 1000)
      this.dialog = true
      if (!this.$store.getters.lineStatus) {
        alert('กรุณาตั้งค่า Line Notify ก่อน')
        this.otpTime = 0
        // return false
      }
      let message
      if (process.env.NODE_ENV === 'production') {
        message = { emp: this.$store.state.users.main.empCode, app: this.appl, message: this.obj.message }
      } else {
        message = { emp: '0090', app: this.appl, message: this.obj.message }
      }

      let res = await this.$store.dispatch('lineOTP', message)
      if (res.status !== 200) {
        this.error = 'send OTP Error ' + res.message
      } else {
        this.error = ''
      }
      // .then(res =>{ console.log(res)}
      // .catch(err => {console.log(err)})
    },
    async checkOTP() {
      let message
      // message = {emp:this.$store.state.users.main.empCode,app:this.appl,OTP:this.otpTEXT}
      if (process.env.NODE_ENV === 'production') {
        message = { emp: this.$store.state.users.main.empCode, app: this.appl, OTP: this.otpTEXT }
      } else {
        message = { emp: '0090', app: this.appl, OTP: this.otpTEXT }
      }
      let result = await this.$store.dispatch('lineOTPCheck', message)
      if (!result.status) {
        this.error = 'รหัส OTP ไม่ถูกต้องกรุณาลองใหม่'
        Object.assign(result, this.obj)
        // alert('opt-Error:'+JSON.stringify(result))
        this.$emit('commitOTP', result)
        return false
      }
      this.clear()
      this.dialog = false
      await this.$nextTick()
      Object.assign(result, this.obj)
      // alert('opt-OK:'+JSON.stringify(result))
      this.$emit('commitOTP', result)
    },
    async closeOTP() {
      this.clear()
      this.dialog = false
      let result = { status: false, message: 'close' }
      Object.assign(result, this.obj)
      // alert('opt-OK:'+JSON.stringify(result))
      this.$emit('commitOTP', result)
    },
    async skipOTP() {
      this.clear()
      this.dialog = false
      let result = { status: true, message: 'OK' }
      Object.assign(result, this.obj)
      // alert('opt-OK:'+JSON.stringify(result))
      this.$emit('commitOTP', result)
    },
    clear() {
      this.otpTEXT = ''
      this.error = ''
      this.otpTime = 60
    },
    decrementTime() {
      this.OptTime--
      if (this.otpTime < 0) {
        clearInterval(this.runT)
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.signIn()
      }
    }
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
  font-size: 2.5rem !important;
  padding: 0;
  margin: 0;
}
.text-field-line-height {
  height: 200px !important;
}
</style>
